import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../provider/authContextType';

const fetchMaritalStatus = async (origin: string | null) => {
  const response = await axios.get(
    `${origin}/administration/getAllMaritalStatus`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

const fetchIdentityDocumentTypes = async (origin: string | null) => {
  const response = await axios.get(
    `${origin}/administration/getAllIdentityDocumentType`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

const fetchCountries = async (origin: string | null) => {
  const response = await axios.get(`${origin}/administration/getAllCountry`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer `,
    },
  });
  return response.data;
};

const fetchStreetTypes = async (origin: string | null) => {
  const response = await axios.get(
    `${origin}/administration/getAllStreetType`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

const fetchDistricts = async (origin: string | null) => {
  const response = await axios.get(`${origin}/administration/getAllDistrict`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer `,
    },
  });
  return response.data;
};

const fetchDepartments = async (origin: string | null) => {
  const response = await axios.get(
    `${origin}/administration/getAllDepartment`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

type State = {
  departmentId: number;
  stateId: number;
};

const fetchStates = async (origin: string | null) => {
  const response = await axios.get(`${origin}/administration/getAllState`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer`,
    },
  });
  return response.data;
};

export const useFetchMaritalStatus = () => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['maritalStatus'],
    queryFn: () => {
      return fetchMaritalStatus(origin);
    },
  });
};

export const useFetchIdentityDocumentTypes = () => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['identityDocumentTypes'],
    queryFn: () => {
      return fetchIdentityDocumentTypes(origin);
    },
  });
};

export const useFetchCountries = () => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => {
      return fetchCountries(origin);
    },
  });
};

export const useFetchStreetTypes = () => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['streetTypes'],
    queryFn: () => {
      return fetchStreetTypes(origin);
    },
  });
};
export const useFetchStates = (deparmentId: number) => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['states'],
    queryFn: () => {
      return fetchStates(origin);
    },
    staleTime: Infinity,
    select: (data) =>
      data.filter((response: State) => response.departmentId === deparmentId),
  });
};
export const useFetchDistricts = (stateId: number) => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['districts'],
    queryFn: () => {
      return fetchDistricts(origin);
    },
    staleTime: Infinity,
    select: (data) =>
      data.filter((response: State) => response.stateId === stateId),
  });
};

export const useFetchDepartments = () => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['departments'],
    queryFn: () => {
      return fetchDepartments(origin);
    },
  });
};
